import { CLASS_NAMES, SELECTORS, EVENTS } from '@bs/constants';

/**
 * A class for the EmailBlock module
 */
export default class EmailBlock {
  /**
   * Constructor function of the EmailBlock class. Must receive one arguments, a DOM
   * node representing the email block.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    /**
     * DOM node that is passed into the constructor
     * @property {object} element DOM node that is passed into the constructor
     */
    this.element = element;

    // Initialize the view
    this.init();
  }

  /**
   * Initializes the view by calling the functions to
   * create DOM references, setup event handlers and
   * then create the event listeners
   * @returns {object} EmailBlock A reference to the current instance of the class
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().populateSourcePageURL().enable();

    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {object} EmailBlock A reference to the current instance of the class
   * @chainable
   */
  cacheDomReferences() {
    this.email_block = this.element;
    this.sourceInputs = this.element.querySelectorAll(
      SELECTORS.SOURCE_PAGE_URL_INPUT
    );
    this.emailInput = this.element.querySelector(
      `.${CLASS_NAMES.EMAIL_BLOCK_EMAIL}`
    );
    return this;
  }

  /**
   * Create event handlers to enable interaction with view
   * @returns {object} Search A reference to the current instance of the class
   * @chainable
   */
  enable() {
    if (this.emailInput) {
      this.emailInput.addEventListener(EVENTS.INPUT, () => {
        if (
          this.emailInput.validity.typeMismatch ||
          this.emailInput.validity.patternMismatch
        ) {
          this.emailInput.setCustomValidity(
            'Please enter a valid email address (example: name@example.com)'
          );
        } else {
          this.emailInput.setCustomValidity('');
        }
      });

      this.emailInput.addEventListener(EVENTS.INVALID, () => {
        if (
          this.emailInput.validity.typeMismatch ||
          this.emailInput.validity.patternMismatch
        ) {
          this.emailInput.setCustomValidity(
            'Please enter a valid email address (example: name@example.com)'
          );
        }
      });
    }

    return this;
  }

  /**
   * Bind event handlers with the proper context of `this`.
   * @returns {object} A reference to the current instance of the class
   * @chainable
   */
  setupHandlers() {
    return this;
  }

  /**
   * Populate the hidden Source_Page_URL field(s)
   * @returns {object} EmailBlock
   */
  populateSourcePageURL() {
    if (!this.sourceInputs?.length) return this;

    let path = window.location.pathname || '/';

    // Keep only alphanumeric, dashes, and slashes
    path = path.replace(/[^a-zA-Z0-9/-]/g, '');

    // Optional: remove trailing slash except root
    if (path.length > 1) {
      path = path.replace(/\/$/, '');
    }

    // Truncate to 255 characters
    path = path.slice(0, 255);

    // Populate every Source_Page_URL hidden input in this block
    this.sourceInputs.forEach((inputEl) => {
      const el = inputEl;
      el.value = path;
    });

    return this;
  }
}
